export default {
  to: "/exams/listing",
  order: 4,
  icon: "mdi-school",
  title: "Exams",
  disabled: false,
  value: 0,
  sublinks: [
    {
      to: "/exams/bookings",
      icon: "mdi-book-edit",
      title: "Bookings",
      disabled: false,
      value: 0,
    },
    {
      to: "/exams/deferrals",
      icon: "history_edu",
      title: "Deferrals",
      disabled: false,
      value: 0,
    },
    {
      to: "/exams/withdrawals",
      icon: "no_sim",
      title: "Withdrawals",
      disabled: false,
      value: 0,
    },
    // {
    //   to: "/exams/current-results",
    //   icon: "mdi-checkbox-multiple-marked",
    //   title: "Exempted Units",
    //   disabled: false,
    //   value: 0,
    // },
    {
      to: "/exams/historical-results",
      icon: "mdi-library",
      title: "Historical Results",
      disabled: false,
      value: 0,
    },
    {
      to: "/exams/transcripts",
      icon: "mdi-script",
      title: "Exam Results",
      disabled: false,
      value: 0,
    },
    {
      to: "/exams/remark",
      icon: "history_edu",
      title: "Remark",
      disabled: false,
      value: 0,
    },
    {
      to: "/exams/timetable",
      icon: "mdi-timetable",
      title: "My Timetable",
      disabled: false,
      value: 0,
    },
    {
      to: "/exams/units",
      icon: "mdi-script",
      title: "My Notes",
      disabled: false,
      value: 0,
    },
  ],
};
